<script lang="ts">
	import { RectangularAvatar } from '@Shelly/shelly-design-system';
	import type { RectangularAvatarPropsTypes } from '@Shelly/shelly-design-system';

	import type { Home } from 'src/types/Home';

	const HOME_ICON = 'fa-solid fa-house-chimney';
	const PREMIUM_ICON = 'fa-solid fa-gem';

	export let home: Home | undefined;
	export let size: RectangularAvatarPropsTypes['size'] = 's';

	$: isPremium = home?.plan === 'premium';
</script>

<RectangularAvatar
	{...$$restProps}
	{size}
	icon={home?.avatar === undefined ? HOME_ICON : undefined}
	image={home?.avatar === undefined ? undefined : home?.avatar?.image}
	defaultImageIcon={HOME_ICON}
	text={home?.avatar?.text || home?.name.charAt(0)}
	backgroundColor={home?.avatar?.backgroundColor}
	avatarOptions={{
		type: isPremium ? 'premium' : null,
		badgeProps: isPremium ? { show: true, icon: PREMIUM_ICON } : { show: false, icon: '' },
	}}
/>
